const home = {
  header: {
    titleLineOne:
      "Wortschatz, Grammatik, Hörverstehen, Ausdrucksfähigkeit und anglophone Kultur (Niveaus A1, A2, B1 und B2 des GER).",
    titleLineOneBis: "Übungstests für Englisch-Zertifizierungen.",
    titleLineTwo: "Vielfältige Aktivitäten und Lernmaterialien",
    titleLineThree: "Nutzung im Unterricht und/oder zu Hause",
    links: [
      "Das iizenglish-Team",
      "So funktioniert’s",
      "In den Medien",
      "Kontakt",
    ],
  },
  moreInfo: "Mehr erfahren",
  gar_notice: "Please access the resources through your school’s LMS.",
  origin_iizenglish: {
    title: "DER URSPRUNG VON IIZENGLISH",
    firstLine: "iizenglish entstand aus einer doppelten Feststellung:",
    liOne:
      "Pädagogische Differenzierung ist unerlässlich, aber im Schulalltag oft schwer umzusetzen.",
    liTwo:
      "Nachhaltiges Lernen bleibt für viele Schülerinnen und Schüler eine Herausforderung.",
    paragraphOne:
      "Deshalb haben wir ein einfaches und intuitives Tool entwickelt, das von Lehrkräften für Lehrkräfte konzipiert wurde, um die Differenzierung zu erleichtern und jedem Lernenden zu helfen, in seinem eigenen Tempo Fortschritte zu machen.",
    paragraphTwo:
      "Dank intelligenter aktiver Wiederholung verwandelt iizenglish das Training in eine effektive und nachhaltige Lernerfahrung, bei der jede Übung das Gelernte festigt und zugleich das Interesse der Lernenden aufrechterhält.",
  },
  offer: {
    title: "DIE VORTEILE UNSERES ANGEBOTS",
    teacherTitle: "FÜR LEHRKRÄFTE",
    studentTitle: "FÜR SCHÜLERINNEN UND SCHÜLER",
    forTeacherAdvantages: [
      "Schnelle Erstellung von Aufgaben für den Unterricht oder für zu Hause aus einer großen Auswahl an Übungen.",
      "Möglichkeit, innerhalb einer Klasse Arbeitsgruppen zu bilden (je nach Bedarf oder Leistungsniveau).",
      "Versand unterschiedlicher Übungen oder derselben Übung mit variierendem Schwierigkeitsgrad.",
      "Erhalt einer personalisierten Auswertung",
    ],
    forStudentsAdvantages: [
      "Übungen mit sofortiger Korrektur und Bewertung",
      "Möglichkeit, die Übung mehrfach zu wiederholen, wobei bei jedem Versuch unterschiedliche Sätze verwendet werden.",
      "Zahlreiche Illustrationen in Kombination mit Audiodateien zur Erleichterung der Wortschatz­memorierung.",
      "Es wird ausschließlich die beste Note berücksichtigt.",
    ],
  },
  plan: {
    allDevice: "AUF ALLEN GERÄTEN VERFÜGBAR",
    howItWorks: "Wie funktioniert’s?",
    plans: [
      "NUR IM ABONNEMENT VERFÜGBAR",
      "{price} inkl. MwSt. pro Schüler/in und Jahr",
      "Kostenlose Demo verfügbar",
    ],
  },
  footer: {
    cgu: "ALLGEMEINE NUTZUNGSBEDINGUNGEN",
    legalNotices: "RECHTLICHE HINWEISE",
  },
  PrivacyPolicy: {
    title: "DATENSCHUTZERKLÄRUNG",
    ressourceUrl:
      "https://files.iizenglish.com/prod/ressources/fr/2023_11_23_Datenschutzerklärung.pdf",
  },
};

export default home;
